import { NgModule } from '@angular/core';

import { ProductDetailsComponent } from '@app/+product/components/product-details/product-details.component';
import { ProductSellerBadgeComponent } from '@app/+product/components/product-seller-badge/product-seller-badge.component';
import { ProductDescriptionComponent } from '@app/+product/components/product-description/product-description.component';
import { DescReassuranceComponent } from '@app/+product/components/product-description/desc-reassurance/desc-reassurance.component';
import { ProductsService } from '@vestiaire/api-sdk-angular';
import { HelpersService } from '@app/shared/services/helpers/helpers.service';
import { ProductRoutingModule } from '@app/+product/product-routing.module';
import { ProductComponent } from '@app/+product/product.component';
import { ProductsArrangementComponent } from '@app/shared/components/products-arrangement/products-arrangement.component';
import { BreadcrumbModule } from '@app/shared/components/breadcrumb/breadcrumb.module';
import { SharedModule } from '@app/shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { SocialShareService } from '@app/shared/services/social-share/social-share.service';
import { DiscussionsModule } from '@app/shared/components/discussions/discussions.module';
import { AlertsModule } from '@app/shared/components/alerts/alerts.module';
import { ProductCategoriesSuggestionsComponent } from './components/product-categories-suggestions/product-categories-suggestions.component';
import { ProductSectionComponent } from './components/product-section/product-section.component';
import { ProductMainHeadingComponent } from './components/product-main-heading/product-main-heading.component';
import { ProductTagsComponent } from './components/product-tags/product-tags.component';
import { ProductImageActionsBarComponent } from './components/product-image-actions-bar/product-image-actions-bar.component';
import { ProductShareComponent } from './components/product-share/product-share.component';
import { MmaoModule } from '@app/shared/components/mmao/mmao.module';
import { ProductPriceComponent } from './components/product-price/product-price.component';
import { ModalPaymentInstallmentComponent } from '@app/shared/components/modals/modal-payment-installment/modal-payment-installment.component';
import { ProductBookmarkActionsComponent } from './components/product-bookmark-actions/product-bookmark-actions.component';
import { ProductSellerBlockComponent } from './components/product-seller-block/product-seller-block.component';
import { ProductSellerDescriptionComponent } from './components/product-seller-description/product-seller-description.component';
import { ProductDescriptionListComponent } from './components/product-description-list/product-description-list.component';
import { ProductUnloadGuard } from './product-unload.guard';
import { AddPicturesComponent } from '@app/+product/components/product-details/add-pictures';
import { LocalisationModalComponent } from '@app/+product/components/product-details/localisation-modal/localisation-modal.component';
import { DeliveryModalComponent } from '@app/+product/components/product-details/delivery-modal/delivery-modal.component';
import { ControlQualityModalComponent } from './components/product-details/control-quality-modal/control-quality-modal.component';
import { LegalWarrantiesModalComponent } from './components/product-description/legal-warranties-modal/legal-warranties-modal.component';
import { ProductMicrodatasService } from '@app/+product/service/product-microdata.service';
import { ProductPageResolver } from './resolvers/product-page.resolver';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';
import { ProductInstallmentComponent } from './components/product-installment/product-installment.component';
import { ProductAuthenticationInfosComponent } from '@app/+product/components/product-details/product-authentication-infos/product-authentication-infos.component';
import { ProductAuthenticationModalComponent } from '@app/+product/components/product-details/product-authentication-modal/product-authentication-modal.component';
import { ReservationEffects } from './store/effects/reservation.effects';
import { ReservationService } from '@app/shared/services/product';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from '@app/+product/store';
import { ProductEffects } from './store/effects/product.effects';
import { AddToCartModule } from '@app/shared/directives/add-to-cart/add-to-cart.module';
import { CarouselImagesModule } from '@app/shared/components/carousel-images/carousel-images.module';
import { ModalDeliveryServiceDescriptionModule } from '@app/shared/components/modals/modal-delivery-service-description/modal-delivery-service-description.module';
import { OpenChatPopinDirective } from './components/product-chat/open-chat-popin-directive';

@NgModule({
  imports: [
    SharedModule,
    ProductRoutingModule,
    BreadcrumbModule,
    DiscussionsModule,
    CarouselImagesModule,
    AlertsModule,
    NgxJsonLdModule,
    MatDialogModule,
    MmaoModule,
    StoreModule.forFeature('reservation', reducers),
    EffectsModule.forFeature([ReservationEffects, ProductEffects]),
    AddToCartModule,
    ModalDeliveryServiceDescriptionModule
  ],
  declarations: [
    ProductComponent,
    AddPicturesComponent,
    LocalisationModalComponent,
    DeliveryModalComponent,
    ControlQualityModalComponent,
    ProductDetailsComponent,
    ProductSellerBadgeComponent,
    LegalWarrantiesModalComponent,
    ProductDescriptionComponent,
    DescReassuranceComponent,
    ProductsArrangementComponent,
    ProductCategoriesSuggestionsComponent,
    ProductSectionComponent,
    ProductMainHeadingComponent,
    ProductTagsComponent,
    ProductImageActionsBarComponent,
    ProductTagsComponent,
    ProductImageActionsBarComponent,
    ProductShareComponent,
    ProductPriceComponent,
    ProductBookmarkActionsComponent,
    ProductSellerBlockComponent,
    ProductSellerDescriptionComponent,
    ProductDescriptionListComponent,
    ProductInstallmentComponent,
    ProductAuthenticationInfosComponent,
    ProductAuthenticationModalComponent,
    OpenChatPopinDirective
  ],
  exports: [SharedModule, ProductSectionComponent],
  providers: [
    ProductsService,
    HelpersService,
    SocialShareService,
    ProductUnloadGuard,
    ReservationService,
    ProductPageResolver,
    ProductMicrodatasService
  ],
  entryComponents: [
    ModalPaymentInstallmentComponent,
    AddPicturesComponent,
    LocalisationModalComponent,
    DeliveryModalComponent,
    ControlQualityModalComponent,
    LegalWarrantiesModalComponent,
    ProductAuthenticationModalComponent
  ]
})
export class ProductModule {}
